<template>
  <b-row v-show="total_rows > per_page" class="mb-3">
    <b-col>
      <b-pagination
        v-model="actual_current_page"
        :total-rows="total_rows"
        :per-page="actual_per_page"
        first-number
        last-number
        :aria-controls="table_id"
        class="mb-0"
      />
    </b-col>
    <b-col v-if="options" cols="3">
      <b-input-group :prepend="selector_rpefix">
        <b-form-select v-model="actual_per_page" :options="options" />
      </b-input-group>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "CustomTablePagination",
  props: {
    options: {
      type: Array,
      default: () => null,
    },
    current_page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 1,
    },
    total_rows: {
      type: Number,
      default: 1,
    },
    table_id: {
      type: String,
      default: null,
    },
    selector_rpefix: {
      type: String,
      default: null,
    },
  },
  computed: {
    actual_current_page: {
      get() {
        return this.current_page;
      },
      set(value) {
        this.$emit("update", { field: "current_page", value });
      },
    },
    actual_per_page: {
      get() {
        return this.per_page;
      },
      set(value) {
        this.$emit("update", { field: "per_page", value });
      },
    },
  },
};
</script>
